<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="Redeem">
    <div class="Redeem__img">
    </div>
    <div class="Redeem__form" :style="{
      height: isConcert('heroes') ? '574px' : 'auto',
    }">
      <div class="Redeem__form__container">
        <img class="Redeem__form__img" src="/img/aliveRedeem.png" alt="Contatto">
        <div class="Redeem__form__padding">
          <div class="Redeem__form__info">{{ $t('insert_code') }}</div>
          <input type="text" v-model="ticket_id">
          <div class="Redeem__form__detail">
            ({{ $t('code_info') }})
          </div>
          <span class="tokBtn" @click="redeemTicket">
                {{ $t('activate') }}
              </span>
          <router-link class="Redeem__form__needHelp" :to="faqRoute">{{ $t('need_help') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapActions,
  mapState,
  mapMutations,
  mapGetters,
} from 'vuex';
import get from 'lodash.get';

export default {
  name: 'Redeem',
  data() {
    return {
      ticket_id: '',
    };
  },
  methods: {
    ...mapMutations(['initModal', 'closeRedeem']),
    ...mapActions(['appReady', 'getMe', 'getPlans', 'playVideoById', 'loadTheVideo']),
    isConcert(name) {
      return this.$store.state.singleV === this.$store.state.concertMap[name];
    },
    redeemTicket() {
      if (!this.ticket_id) {
        this.initModal({
          display: true,
          title: this.$t('error'),
          text: this.$t('BLANK_REDEEAM_CODE'),
          cta: this.$t('close'),
          callback: 'close',
          animation: 'tada',
        });
        return;
      }
      const that = this;
      this.api.post('/claim-plan',
        {
          type: 'ticket',
          ticket_sku: that.redeem.offers[0],
          ticket_id: that.ticket_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-tok-token': that.getToken,
          },
        })
        .then((response) => {
          // console.log(response);
          if (response.data.valid) {
            that.getMe()
              .then(() => {
                that.closeRedeem();
                if (that.redeem.play === true) {
                  that.playVideoById(that.redeem);
                  const postRedeemRoute = get(that, 'redeem.postRedeemRoute', '/');
                  that.$router.push(postRedeemRoute);
                }
                if (that.redeem.load === true) {
                  that.loadTheVideo(that.redeem);
                  that.$router.push('/');
                }
              });
          } else {
            that.closeRedeem();
            that.initModal({
              display: true,
              title: this.$t('error'),
              text: this.$t('wrong_code'),
              cta: this.$t('close'),
              callback: 'close',
              animation: 'tada',
            });
            that.ticket_id = '';
          }
          /*
          if (response.data.valid) {
            const plan = find(get(that, 'availablePlans.plans', false), p => p.title === response.data.plan);
            if (plan) {
              window.ga('tok.send', 'event', 'Subscription Paywall', 'Pay Item Acquired', get(plan, 'id'));
            }
            that.getMe()
              .then(() => {
                that.getPlans(true)
                  .then(() => {
                    that.$router.push('/paywall');
                  })
                  .catch(() => {
                    window.app.$log.info('Unable retrive plans');
                    that.$router.push('/paywall');
                  });
              })
              .catch(() => {
                window.app.$log.info('Unable to retrive user info');
                that.$router.push('/paywall');
              });
          } else {
            that.initModal({
              display: true,
              title: 'ERROR',
              text: 'generic error',
              cta: this.$t('close'),
              callback: 'closeAnPayWall',
              animation: 'tada',
            });
          }
          */
        })
        .catch(() => {
          that.initModal({
            display: true,
            title: this.$t('error'),
            text: 'Payment processing error',
            cta: this.$t('close'),
            callback: 'close',
            animation: 'tada',
          });
        });
    },
  },
  computed: {
    ...mapState(['api', 'availablePlans', 'redeem', 'conf', 'env']),
    ...mapGetters(['getToken', 'faqRoute']),
  },
};
</script>

<style scoped lang="scss">
.Redeem {
  background-size: cover;
  background-position: bottom center;
  width: 100%;
  min-height: 100vh;
  position: relative;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-top: 70px;
  &__img{
    img{
      margin: 0 auto;
      display: block;
      max-width: 90%;
      padding-bottom: 50px;
    }
  }
  &__form {
    background-color: #191919;
    padding: 0;
    // height: 574px;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    width: 100%;
    max-width: 773px;
    margin: 20px;
    border: 1px solid white;
    align-items: center;

    &__img{
      width: 100%;
    }

    &__container {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    &__padding {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 30px;
      width: fit-content;
      margin: 0 auto;
    }

    &__info {
      color: #ffffff;
      font-size: 22px;
      text-align: center;
      margin-bottom: 40px;
    }

    &__detail {
      color: #ffffff;
      text-align: center;
      font-size: 14px;
      margin-bottom: 20px;
    }

    &__noCode {
      text-align: center;
      color: #611518;
      margin-top: 40px;
      border-bottom: 1px solid #611518;
      padding-bottom: 5px;
      margin-bottom: 5px;
    }

    &__buyTicket {
      text-align: center;
      color: #000;
      text-decoration: underline;
    }

    &__needHelp {
      display: flex;
      flex: auto;
      color: #fff;
      text-decoration: underline;
      align-items: flex-end;
      justify-content: center;
      margin-top: 30px;
    }

    label {
      color: rgba(255, 255, 255, 0.8);
      margin-bottom: 5px;
      text-align: center;
    }

    input {
      margin-bottom: 20px;
      padding: 8px;
      border-radius: 5px;
      border: 1px solid #000;
      font-size: 16px;
      background-color: rgba(255, 255, 255, 1);
      color: #000;
    }

    .tokBtn {
      margin-top: 20px;
      // background-color: #611518;
      // color: white;
      border: 1px solid white;
      height: 40px;
    }
  }
}
</style>
